module.exports = __webpack_public_path__ + "static/media/04.5581e13a.jpg";